<script>
  import { ElementIntersectionObserver } from '@nrk/dh-basis-common'
  import { onMount } from 'svelte'

  onMount(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const intersection = new ElementIntersectionObserver(
      Array.from(document.querySelectorAll('.kartmarkor [data-region]')),
      onIntersectionChange,
      { rootMargin: '16000px 0px 0px 0px' },
    )
  })

  let visibleRegions
  $: activeRegion = visibleRegions?.[visibleRegions.length - 1]
  function onIntersectionChange(entries) {
    visibleRegions = entries
      .filter((it) => it.isIntersecting)
      .map((it) => it.target.dataset?.region?.toLowerCase())
  }
</script>

<slot {activeRegion} {visibleRegions} />
